// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function ErrorOccured(props) {
  return JsxRuntime.jsx("div", {
    children: "Error occurred",
    className: "flex justify-center font-bold text-lg text-red-600"
  });
}

let make = ErrorOccured;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
